import React from 'react';
import { Icon } from 'b3';
import cx from "classnames";

export default class FormElement extends React.Component {
	constructor(props) {
    	super(props); 
        this.state = {
            focussed: false
        };
  	}

    handleOnBlur(e) {
        this.setState({ focussed: false });
    }

    handleOnFocus(e) {
        this.setState({ focussed: true });
    }

    render() {
        var { icon, label, children, valid, style } = this.props;
        var { focussed } = this.state;
        var classNames = cx("form-element", (!valid ? "error" : ""), (focussed ? "focussed" : "" ) );
        
        var childrenWithProps = React.Children.map(this.props.children, (child) => {
            return child
                ? React.cloneElement(child, { onBlur: this.handleOnBlur.bind(this), onFocus: this.handleOnFocus.bind(this) })
                : child;
        });

        return (
    		<div className={classNames} style={style}>

                <div className="form-element-inner">

                    { icon &&
                        <Icon icon={ icon } size={24} />
                    }
                    
                    { label && 
                        <span className="input-label">{ label }</span>
                    }

                </div>
                
                <span className="input-container">{childrenWithProps}</span>
            </div>
        );
    }
}

FormElement.defaultProps = {
    icon : null,
    valid: true
};



// WEBPACK FOOTER //
// ./app/b3/inputs/FormElement.js